import React, { useEffect, useRef } from 'react'
import { SearchBig, Truckbody, Tires, Road, AddwithWhiteCircle, UpdatePencil, DeleteDustbin } from '../../components/AllSvg'
import { useState } from 'react';
import axios from 'axios';
import { BASE_URL3 } from '../../config/axios';
import { CSSForSelectModern, handleErrorToast } from '../../components/CustomFunctions';
import { toast, ToastContainer } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { StickyNote, X, Save, Loader, AlertCircle, Briefcase, Plus, Trash2, FileText, SectionIcon, AlertTriangle, Search } from "lucide-react";

import Select from 'react-select';
import { AddModalButton, DeleteModalButton, UpdateModalButton } from '../../components/DynamicButtons';

// const AddNotes = ({ getNotes, worktypeName }) => {
//     const [formData, setFormData] = useState({
//         worktype_id: "null",
//         data: [{
//             description: "",
//         }]
//     });


//     console.log("formdata console")
//     console.log(formData)


//     const [isSubmitted, setIsSubmitted] = useState(false);

//     const [show, setShow] = useState(false);

//     const handleShow = () => {

//         setShow(true);
//         getCompany();
//     }

//     const handleClose = () => {
//         setShow(false);

//         setFormData({
//             worktype: "null",
//             data: [{
//                 description: "",
//             }]
//         })
//         setErrors({});
//     }

//     const addNewDescription = () => {
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             data: [...prevFormData.data, { description: "" }],
//         }));
//     };


//     const handleDescriptionChange = (index, value) => {
//         const updatedData = [...formData.data];
//         updatedData[index].description = value;
//         setFormData({ ...formData, data: updatedData });

//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[`description_${index}`];
//                 return updatedErrors;
//             });
//         }
//     };
//     const fileInputRefs = useRef([]);

//     const handleRemoveData = (index) => {
//         setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
//         fileInputRefs.current.splice(index, 1);
//     };


//     const [errors, setErrors] = useState({});

//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};


//         const requiredFields = ["worktype_id"];
//         requiredFields.forEach((field) => {
//             if (!formData[field] || formData[field] === "null") {
//                 newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//             }
//         });


//         formData.data.forEach((item, index) => {
//             if (!item.description.trim()) {
//                 newErrors[`description_${index}`] = `This is required field!`;
//             }
//         });

//         setErrors(newErrors);
//         setIsSubmitted(true);

//         return Object.keys(newErrors).length === 0;
//     };



//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {

//             const loadingToastId = toast.loading("Loading: Please wait...");
//             setLoading(true);
//             try {
//                 let res = await axios.post(`${BASE_URL3}/project/note/`, formData)

//                 if (res.status === 200 || res.status === 200) {
//                     getNotes();
//                     handleClose();
//                     toast.dismiss(loadingToastId);
//                     toast.success("Client Name Added successfully!");

//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {

//                 if (err.response) {
//                     toast.dismiss(loadingToastId);
//                     const errorData = err.response.data;

//                     if (typeof errorData.error === 'string') {

//                         toast.error(`Error: ${errorData.error}`);
//                     } else if (typeof errorData === 'object' && errorData !== null) {

//                         Object.entries(errorData).forEach(([field, messages]) => {
//                             messages.forEach(message => toast.error(`"${field}": ${message}`));
//                         });
//                     } else {
//                         toast.error('Error:- Failed to Process!');
//                     }
//                 } else {
//                     toast.error('Error processing your request.');
//                 }
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }

//         }
//     };
//     const [company, setCompany] = useState([]);

//     const getCompany = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL3}/project/subcompany/`);
//             setCompany(res.data);
//         } catch (error) {
//             console.error(error);

//         }
//     }




//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value,
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };


//     const removeDescription = (index) => {
//         const updatedData = formData.data.filter((_, i) => i !== index);
//         setFormData({ ...formData, data: updatedData });


//         setErrors((prevErrors) => {
//             const updatedErrors = { ...prevErrors };
//             delete updatedErrors[`description_${index}`];


//             const reorderedErrors = {};
//             Object.keys(updatedErrors).forEach((key) => {
//                 if (key.startsWith("description_")) {
//                     const idx = parseInt(key.split("_")[1], 10);
//                     reorderedErrors[
//                         `description_${idx > index ? idx - 1 : idx}`
//                     ] = updatedErrors[key];
//                 } else {
//                     reorderedErrors[key] = updatedErrors[key];
//                 }
//             });

//             return reorderedErrors;
//         });
//     };


//     return (
//         <>
//             <button className='upload-svg' onClick={handleShow}>
//                 <AddwithWhiteCircle /> {"Notes"}
//             </button>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Notes</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">

//                         <div className='flex-column' style={{ justifyContent: "space-between" }}>
//                             <div className='flex-row justify-between'>

//                                 <div className="flex-column form-group-select">
//                                     <label className="form-labels">Select Work Type:
//                                     </label>
//                                     <select
//                                         name="worktype_id"
//                                         value={formData.worktype_id}
//                                         onChange={handleInputChange}
//                                         className={`form-input form-group-selection ${errors.worktype_id ? 'error' : inputState.worktype_id ? 'success' : ''}`}
//                                     >
//                                         <option value="null" >Select Work Type</option>
//                                         {Array.isArray(worktypeName) && worktypeName.map(item => (

//                                             <option key={item.id} value={item.id}>
//                                                 {item.title}
//                                             </option>
//                                         ))}

//                                     </select>

//                                     {errors.worktype_id && (
//                                         <span className="error-message">{errors.worktype_id}</span>
//                                     )}

//                                 </div>
//                                 {/* <div className="bdy-div flex-cont justify-around"> */}
//                                 <div className="flex-column ">
//                                     <button className='upload-svg' onClick={addNewDescription}>
//                                         <AddwithWhiteCircle /> Add More Description
//                                     </button>
//                                 </div>


//                             </div>
//                             <table className="nested-table-lightblue width-90vw payment border-table">
//                                 <thead className='border-table'>
//                                     <tr>
//                                         <th className='text-center' style={{ width: "5%" }}>S.No.</th>
//                                         <th className='text-center'>Description</th>
//                                         <th style={{ width: "5%" }}>Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {formData.data?.map((item, index) => (
//                                         <tr key={index} style={{ border: "none" }}>
//                                             <td className='font-weight600 text-center'>{index + 1}.</td>
//                                             <td className='notes-description'>
//                                                 <textarea
//                                                     rows="3"
//                                                     placeholder={`Enter description ${index + 1}`}
//                                                     value={item.description}
//                                                     onChange={(e) =>
//                                                         handleDescriptionChange(index, e.target.value)
//                                                     }
//                                                     className="form-input-textarea"
//                                                     style={{ width: "90%", marginLeft: "4%" }}
//                                                 />
//                                                 {errors[`description_${index}`] && (
//                                                     <div className="error-message text-center">{errors[`description_${index}`]}</div>
//                                                 )}
//                                             </td>
//                                             <td className='text-center'>
//                                                 {formData.data.length > 1 &&
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeDescription(index)}
//                                                         className="remove-btn"
//                                                     >
//                                                         ❌
//                                                     </button>
//                                                 }
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>



//                             {/* </div> */}




//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <div className="button-models-gap-116 " >
//                     <div className="">
//                         <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
//                     </div>

//                     <div className="">
//                         <button onClick={handleSubmit} type='submit' className="model-button model-button-submit">Submit</button>
//                     </div>

//                 </div>

//                 <p className="error-message font-size-text margin-top40px">
//                     {isSubmitted && Object.keys(errors).length > 0 && (
//                         Object.keys(errors).length > 3 ? (
//                             <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
//                         ) : (
//                             Object.keys(errors).map((field) =>
//                                 field.charAt(0).toUpperCase() + field.slice(1)
//                             ).join(', ') + ' are required!'
//                         )
//                     )}
//                 </p>
//             </Modal>
//         </>
//     );
// };



const AddNotes = ({ getNotes, worktypeName }) => {
    const initialForm = {
        worktype_id: "null",
        data: [{ description: "" }],
    };

    const [formData, setFormData] = useState(initialForm);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [searchTerm, setSearchTerm] = useState("");

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        setFormData(initialForm);
        setErrors({});
        setInputState({});
        setSearchTerm("");
    };

    /* ===================== WORK TYPE SELECT ===================== */
    const workTypeOptions = (worktypeName || [])
        .filter((w) => w.title?.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((w, index) => ({ value: w.id, label: `${index + 1}. ${w.title}` }));

    const handleWorkTypeChange = (selected) => {
        setFormData((prev) => ({ ...prev, worktype_id: selected ? selected.value : "null" }));
        setInputState((prev) => ({ ...prev, worktype_id: selected ? "green" : "" }));
        if (selected) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.worktype_id;
                return updated;
            });
        }
    };

    /* ===================== DESCRIPTIONS ===================== */
    const addNewDescription = () => {
        setFormData((prev) => ({
            ...prev,
            data: [...prev.data, { description: "" }],
        }));
    };

    const handleDescriptionChange = (index, value) => {
        setFormData((prev) => ({
            ...prev,
            data: prev.data.map((d, i) => (i === index ? { ...d, description: value } : d)),
        }));
        if (value.trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[`description_${index}`];
                return updated;
            });
        }
    };

    const removeDescription = (index) => {
        setFormData((prev) => ({
            ...prev,
            data: prev.data.filter((_, i) => i !== index),
        }));
        // error keys ko re-index karo
        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[`description_${index}`];
            const reordered = {};
            Object.keys(updated).forEach((key) => {
                if (key.startsWith("description_")) {
                    const idx = parseInt(key.split("_")[1], 10);
                    reordered[`description_${idx > index ? idx - 1 : idx}`] = updated[key];
                } else {
                    reordered[key] = updated[key];
                }
            });
            return reordered;
        });
    };

    /* ===================== VALIDATION + SUBMIT ===================== */
    const validateForm = () => {
        const newErrors = {};
        if (!formData.worktype_id || formData.worktype_id === "null") {
            newErrors.worktype_id = "Work Type is required!";
        }
        formData.data.forEach((item, index) => {
            if (!item.description.trim()) {
                newErrors[`description_${index}`] = "Description is required!";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL3}/project/note/`, formData);
            if (res.status === 200 || res.status === 201) {
                getNotes();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Notes Added successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const errorCount = Object.keys(errors).length;

    return (
        <>
            <AddModalButton onClick={handleShow} title="Add Notes" />


            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                {/* ===== HEADER ===== */}
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper">
                            <StickyNote size={24} />
                        </div>
                        <div>
                            <Modal.Title>Add Notes</Modal.Title>
                            <p className="header-subtitle">Select a work type and add its notes</p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                {/* ===== BODY ===== */}
                <Modal.Body className="modern-modal-body">
                    <form onSubmit={handleSubmit} className="project-form">
                        <div className="form-section animate-fade-in">
                            <div className="section-title">
                                <SectionIcon icon={StickyNote} color="#8b5cf6" />
                                <div>
                                    <h4>Notes Information</h4>
                                    <p className="section-subtitle">These notes load automatically when this work type is selected in a quotation</p>
                                </div>
                            </div>

                            <div className="form-grid">
                                <div className="form-field full-width">
                                    <label>
                                        <Briefcase size={14} /> Work Type<span className="required">*</span>
                                    </label>
                                    <Select
                                        options={workTypeOptions}
                                        onChange={handleWorkTypeChange}
                                        value={workTypeOptions.find((o) => o.value === formData.worktype_id) || null}
                                        placeholder="Select Work Type"
                                        isClearable
                                        isSearchable
                                        isMulti={false}
                                        inputValue={searchTerm}
                                        onInputChange={(input) => setSearchTerm(input)}
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelectModern}
                                    />
                                    {errors.worktype_id && (
                                        <span className="error-message">
                                            <AlertCircle size={12} /> {errors.worktype_id}
                                        </span>
                                    )}
                                </div>

                                <div className="form-field full-width">
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                        <label style={{ margin: 0 }}>
                                            <FileText size={14} /> Descriptions
                                            <span className="remarks-count" style={{ marginLeft: 8 }}>{formData.data.length}</span>
                                        </label>
                                        <button type="button" className="btn-add-remark" onClick={addNewDescription}>
                                            <Plus size={16} /> Add More Description
                                        </button>
                                    </div>

                                    <div className="remark-table-wrapper" style={{ maxHeight: 360 }}>
                                        <table className="remark-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 60 }}>S.No.</th>
                                                    <th>Description</th>
                                                    <th style={{ width: 80 }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}.</td>
                                                        <td>
                                                            <textarea
                                                                rows={3}
                                                                placeholder={`Enter description ${index + 1}`}
                                                                value={item.description}
                                                                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                                                className={errors[`description_${index}`] ? "error" : ""}
                                                                style={{ width: "100%" }}
                                                            />
                                                            {errors[`description_${index}`] && (
                                                                <span className="error-message">
                                                                    <AlertCircle size={12} /> {errors[`description_${index}`]}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {formData.data.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="remark-delete"
                                                                    title="Remove description"
                                                                    onClick={() => removeDescription(index)}
                                                                >
                                                                    <Trash2 size={15} />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                {/* ===== FOOTER ===== */}
                <Modal.Footer className="modern-modal-footer">
                    <div>
                        {errorCount > 0 && (
                            <div className="tab-error-message">
                                <AlertCircle size={14} />
                                <span>
                                    {errorCount > 3
                                        ? "Please fill all mandatory fields!"
                                        : "Please fill the required fields"}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="submit-buttons">
                        <button type="button" className="btn-secondaryy" onClick={handleClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn-primaryy" disabled={loading} onClick={handleSubmit}>
                            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                            <span>{loading ? "Saving..." : "Save Notes"}</span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// const UpdateNotes = ({ getNotes, worktypeName, i }) => {
//     const [formData, setFormData] = useState({
//         worktype_id: "null",
//         data: [{
//             description: "",
//         }]
//     });


//     console.log("formdata console")
//     console.log(formData)


//     const [isSubmitted, setIsSubmitted] = useState(false);

//     const [show, setShow] = useState(false);

//     const handleShow = () => {

//         setShow(true);
//         setFormData(i);
//     }

//     const handleClose = () => {
//         setShow(false);

//         setFormData({
//             worktype: "null",
//             data: [{
//                 description: "",
//             }]
//         })
//         setErrors({});
//     }

//     const addNewDescription = () => {
//         setFormData((prevFormData) => ({
//             ...prevFormData,
//             data: [...prevFormData.data, { description: "" }],
//         }));
//     };

//     const handleDescriptionChange = (index, value) => {
//         const updatedData = [...formData.data];
//         updatedData[index].description = value;
//         setFormData({ ...formData, data: updatedData });

//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[`description_${index}`];
//                 return updatedErrors;
//             });
//         }
//     };
//     const fileInputRefs = useRef([]);



//     const [errors, setErrors] = useState({});

//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};

//         const requiredFields = [];
//         requiredFields.forEach((field) => {
//             if (!formData[field] || formData[field] === "null") {
//                 newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//             }
//         });

//         formData.data.forEach((item, index) => {
//             if (!item.description.trim()) {
//                 newErrors[`description_${index}`] = `This is required field!`;
//             }
//         });

//         setErrors(newErrors);
//         setIsSubmitted(true);

//         return Object.keys(newErrors).length === 0;
//     };



//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {

//             const loadingToastId = toast.loading("Loading: Please wait...");
//             setLoading(true);
//             try {
//                 let res = await axios.put(`${BASE_URL3}/project/note/${i.id}/`, formData)

//                 if (res.status === 200 || res.status === 200) {
//                     getNotes();
//                     handleClose();
//                     toast.dismiss(loadingToastId);
//                     toast.success("Notes Data Updated successfully!");

//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {

//                 if (err.response) {
//                     toast.dismiss(loadingToastId);
//                     const errorData = err.response.data;

//                     if (typeof errorData.error === 'string') {

//                         toast.error(`Error: ${errorData.error}`);
//                     } else if (typeof errorData === 'object' && errorData !== null) {

//                         Object.entries(errorData).forEach(([field, messages]) => {
//                             messages.forEach(message => toast.error(`"${field}": ${message}`));
//                         });
//                     } else {
//                         toast.error('Error:- Failed to Process!');
//                     }
//                 } else {
//                     toast.error('Error processing your request.');
//                 }
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }

//         }
//     };




//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value,
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };


//     const removeDescription = (index) => {
//         const updatedData = formData.data.filter((_, i) => i !== index);
//         setFormData({ ...formData, data: updatedData });


//         setErrors((prevErrors) => {
//             const updatedErrors = { ...prevErrors };
//             delete updatedErrors[`description_${index}`];


//             const reorderedErrors = {};
//             Object.keys(updatedErrors).forEach((key) => {
//                 if (key.startsWith("description_")) {
//                     const idx = parseInt(key.split("_")[1], 10);
//                     reorderedErrors[
//                         `description_${idx > index ? idx - 1 : idx}`
//                     ] = updatedErrors[key];
//                 } else {
//                     reorderedErrors[key] = updatedErrors[key];
//                 }
//             });

//             return reorderedErrors;
//         });
//     };


//     return (
//         <>
//             <button className='model-edit-button' onClick={handleShow}>
//                 <UpdatePencil />
//             </button>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-add-client-details">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Update Notes Data</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">

//                         <div className='flex-column' style={{ justifyContent: "space-between" }}>
//                             <div className='flex-row justify-between'>

//                                 <div className="flex-column form-group-select">
//                                     <label className="form-labels">Select Work Type <span className='required'>(Read-Only)</span>
//                                     </label>
//                                     <input
//                                         name="worktype_id"
//                                         value={i?.worktype?.title}
//                                         disabled
//                                         onChange={handleInputChange}
//                                         className={`form-input form-group-selection ${errors.worktype_id ? 'error' : inputState.worktype_id ? 'success' : ''}`}
//                                     />


//                                 </div>
//                                 {/* <div className="bdy-div flex-cont justify-around"> */}
//                                 <div className="flex-column ">
//                                     <button className='upload-svg' onClick={addNewDescription}>
//                                         <AddwithWhiteCircle /> Add More Description
//                                     </button>
//                                 </div>


//                             </div>
//                             <table className="nested-table-lightblue width-90vw payment border-table">
//                                 <thead className='border-table'>
//                                     <tr>
//                                         <th className='text-center' style={{ width: "5%" }}>S.No.</th>
//                                         <th className='text-center'>Description</th>
//                                         <th style={{ width: "5%" }}>Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {formData.data?.map((item, index) => (
//                                         <tr key={index} style={{ border: "none" }}>
//                                             <td className='font-weight600 text-center'>{index + 1}.</td>
//                                             <td className='notes-description'>
//                                                 <textarea
//                                                     rows="3"
//                                                     placeholder={`Enter description ${index + 1}`}
//                                                     value={item.description}
//                                                     onChange={(e) =>
//                                                         handleDescriptionChange(index, e.target.value)
//                                                     }
//                                                     className="form-input-textarea"
//                                                     style={{ width: "90%", marginLeft: "4%" }}
//                                                 />
//                                                 {errors[`description_${index}`] && (
//                                                     <div className="error-message text-center">{errors[`description_${index}`]}</div>
//                                                 )}
//                                             </td>
//                                             <td className='text-center'>
//                                                 {formData.data.length > 1 &&
//                                                     <button
//                                                         type="button"
//                                                         onClick={() => removeDescription(index)}
//                                                         className="remove-btn"
//                                                     >
//                                                         ❌
//                                                     </button>
//                                                 }
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>



//                             {/* </div> */}




//                         </div>
//                     </div>
//                 </Modal.Body>
//                 <div className="button-models-gap-116 " >
//                     <div className="">
//                         <button type="button" onClick={handleClose} className="model-button-cancel model-button   font-weight500  ">Cancel</button>
//                     </div>

//                     <div className="">
//                         <button onClick={handleSubmit} type='submit' className="model-button model-button-submit">Update</button>
//                     </div>

//                 </div>

//                 <p className="error-message font-size-text margin-top40px">
//                     {isSubmitted && Object.keys(errors).length > 0 && (
//                         Object.keys(errors).length > 3 ? (
//                             <h5 className="text-center" style={{ marginTop: "15px" }} >Please fill all mandatory fields!</h5>
//                         ) : (
//                             Object.keys(errors).map((field) =>
//                                 field.charAt(0).toUpperCase() + field.slice(1)
//                             ).join(', ') + ' are required!'
//                         )
//                     )}
//                 </p>
//             </Modal>
//         </>
//     );
// };

const UpdateNotes = ({ i, getNotes, worktypeName }) => {
    const buildForm = () => ({
        worktype_id: i?.worktype?.id || i?.worktype_id || "null",
        data:
            i?.data?.length > 0
                ? i.data.map((d) => ({ ...d, description: d.description || "" }))
                : [{ description: "" }],
    });

    const [formData, setFormData] = useState(buildForm());
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [searchTerm, setSearchTerm] = useState("");

    // Modal khulte hi saved note form me load karo
    const handleShow = () => {
        setFormData(buildForm());
        setErrors({});
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setErrors({});
        setSearchTerm("");
    };

    /* ===================== WORK TYPE SELECT ===================== */
    const workTypeOptions = (worktypeName || [])
        .filter((w) => w.title?.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((w, index) => ({ value: w.id, label: `${index + 1}. ${w.title}` }));

    const handleWorkTypeChange = (selected) => {
        setFormData((prev) => ({ ...prev, worktype_id: selected ? selected.value : "null" }));
        if (selected) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated.worktype_id;
                return updated;
            });
        }
    };

    /* ===================== DESCRIPTIONS ===================== */
    const addNewDescription = () => {
        setFormData((prev) => ({ ...prev, data: [...prev.data, { description: "" }] }));
    };

    const handleDescriptionChange = (index, value) => {
        setFormData((prev) => ({
            ...prev,
            data: prev.data.map((d, idx) => (idx === index ? { ...d, description: value } : d)),
        }));
        if (value.trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[`description_${index}`];
                return updated;
            });
        }
    };

    const removeDescription = (index) => {
        setFormData((prev) => ({ ...prev, data: prev.data.filter((_, idx) => idx !== index) }));
        setErrors((prev) => {
            const updated = { ...prev };
            delete updated[`description_${index}`];
            const reordered = {};
            Object.keys(updated).forEach((key) => {
                if (key.startsWith("description_")) {
                    const idx = parseInt(key.split("_")[1], 10);
                    reordered[`description_${idx > index ? idx - 1 : idx}`] = updated[key];
                } else {
                    reordered[key] = updated[key];
                }
            });
            return reordered;
        });
    };

    /* ===================== VALIDATION + SUBMIT ===================== */
    const validateForm = () => {
        const newErrors = {};
        if (!formData.worktype_id || formData.worktype_id === "null") {
            newErrors.worktype_id = "Work Type is required!";
        }
        formData.data.forEach((item, index) => {
            if (!item.description.trim()) {
                newErrors[`description_${index}`] = "Description is required!";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = await axios.put(`${BASE_URL3}/project/note/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                getNotes();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Notes Updated successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const errorCount = Object.keys(errors).length;

    return (
        <>
            <UpdateModalButton onClick={handleShow} title="Update Notes" />


            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper">
                            <StickyNote size={24} />
                        </div>
                        <div>
                            <Modal.Title>Update Notes</Modal.Title>
                            <p className="header-subtitle">Edit the work type and its notes</p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="modern-modal-body">
                    <form onSubmit={handleSubmit} className="project-form">
                        <div className="form-section animate-fade-in">
                            <div className="section-title">
                                <SectionIcon icon={StickyNote} color="#8b5cf6" />
                                <div>
                                    <h4>Notes Information</h4>
                                    <p className="section-subtitle">These notes load automatically when this work type is selected in a quotation</p>
                                </div>
                            </div>

                            <div className="form-grid">
                                <div className="form-field full-width">
                                    <label>
                                        <Briefcase size={14} /> Work Type<span className="required">*</span>
                                    </label>
                                    <Select
                                        options={workTypeOptions}
                                        onChange={handleWorkTypeChange}
                                        value={workTypeOptions.find((o) => o.value === formData.worktype_id) || null}
                                        placeholder="Select Work Type"
                                        isClearable
                                        isSearchable
                                        isMulti={false}
                                        inputValue={searchTerm}
                                        onInputChange={(input) => setSearchTerm(input)}
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelectModern}
                                    />
                                    {errors.worktype_id && (
                                        <span className="error-message">
                                            <AlertCircle size={12} /> {errors.worktype_id}
                                        </span>
                                    )}
                                </div>

                                <div className="form-field full-width">
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                        <label style={{ margin: 0 }}>
                                            <FileText size={14} /> Descriptions
                                            <span className="remarks-count" style={{ marginLeft: 8 }}>{formData.data.length}</span>
                                        </label>
                                        <button type="button" className="btn-add-remark" onClick={addNewDescription}>
                                            <Plus size={16} /> Add More Description
                                        </button>
                                    </div>

                                    <div className="remark-table-wrapper" style={{ maxHeight: 360 }}>
                                        <table className="remark-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 60 }}>S.No.</th>
                                                    <th>Description</th>
                                                    <th style={{ width: 80 }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.data.map((item, index) => (
                                                    <tr key={item.id || index}>
                                                        <td>{index + 1}.</td>
                                                        <td>
                                                            <textarea
                                                                rows={3}
                                                                placeholder={`Enter description ${index + 1}`}
                                                                value={item.description}
                                                                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                                                className={errors[`description_${index}`] ? "error" : ""}
                                                                style={{ width: "100%" }}
                                                            />
                                                            {errors[`description_${index}`] && (
                                                                <span className="error-message">
                                                                    <AlertCircle size={12} /> {errors[`description_${index}`]}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {formData.data.length > 1 && (
                                                                <button
                                                                    type="button"
                                                                    className="remark-delete"
                                                                    title="Remove description"
                                                                    onClick={() => removeDescription(index)}
                                                                >
                                                                    <Trash2 size={15} />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                <Modal.Footer className="modern-modal-footer">
                    <div>
                        {errorCount > 0 && (
                            <div className="tab-error-message">
                                <AlertCircle size={14} />
                                <span>
                                    {errorCount > 3
                                        ? "Please fill all mandatory fields!"
                                        : "Please fill the required fields"}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="submit-buttons">
                        <button type="button" className="btn-secondaryy" onClick={handleClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn-primaryy" disabled={loading} onClick={handleSubmit}>
                            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                            <span>{loading ? "Updating..." : "Update Notes"}</span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};
const DeleteNotes = ({ i, getData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const res = await axios.delete(`${BASE_URL3}/project/note/${i.id}/`);

            if (res.status === 200 || res.status === 204) {
                await getData();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const linesCount = i?.data?.length || 0;

    return (
        <>
            <DeleteModalButton title="Delete Notes" onClick={handleShow} />

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="modern-project-modal"
                size="md"
                centered
            >
                {/* ===== HEADER ===== */}
                <Modal.Header className="modern-modal-header delete-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper delete-icon-wrapper">
                            <Trash2 size={22} />
                        </div>
                        <div>
                            <Modal.Title>Delete Notes</Modal.Title>
                            <p className="header-subtitle">This action cannot be undone</p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                {/* ===== BODY ===== */}
                <Modal.Body className="modern-modal-body">
                    <div className="delete-confirm-wrap">
                        <div className="delete-warning-icon">
                            <AlertTriangle size={34} />
                        </div>

                        <h4 className="delete-confirm-title">
                            Are you sure you want to delete these notes?
                        </h4>
                        <p className="delete-confirm-subtitle">
                            All notes of this work type will be permanently removed from the system.
                        </p>

                        {/* Notes Preview Card */}
                        {(i?.worktype?.title || linesCount > 0) && (
                            <div className="delete-preview-card">
                                <div className="delete-preview-icon">
                                    <StickyNote size={16} />
                                </div>
                                <div className="delete-preview-content">
                                    <div className="delete-preview-name">
                                        <span>{i?.worktype?.title || 'Untitled WorkType'}</span>
                                    </div>
                                    <div className="delete-preview-meta">
                                        {i?.worktype?.title && (
                                            <span className="delete-preview-chip">
                                                <Briefcase size={12} /> {i.worktype.title}
                                            </span>
                                        )}
                                        {linesCount > 0 && (
                                            <span className="delete-preview-chip">
                                                <StickyNote size={12} /> {linesCount} {linesCount === 1 ? 'note' : 'notes'}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="delete-warning-note">
                            <AlertCircle size={14} />
                            <span>This will permanently delete the notes of this work type.</span>
                        </div>
                    </div>
                </Modal.Body>

                {/* ===== FOOTER ===== */}
                <Modal.Footer className="modern-modal-footer">
                    <button
                        type="button"
                        className="btn-secondaryy"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleFormSubmitDelete}
                        className="btn-danger-delete"
                        disabled={loading}
                    >
                        {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                        <span>{loading ? 'Deleting...' : 'Delete Notes'}</span>
                    </button>
                </Modal.Footer>
            </Modal>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

// const Notes = ({ worktypeName, notesData, getData, buffer }) => {


//     const [searchQuery, setSearchQuery] = useState("");
//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//     };

//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div >
//                 <div className="attendance-box">
//                     <div className="datagrid-container">
//                         <div className="custom-table-background" style={{ height: "66vh" }}>
//                             <div className="">
//                                 <div className="">
//                                     <div className="table-box ">
//                                         <div className="flex-row table-heading" style={{ justifyContent: "end" }}>
//                                             <div className="table-searchh">


//                                             </div>
//                                             {/* <WorktypeCU getData={getnotes} usedFor="Add" /> */}
//                                             <AddNotes worktypeName={worktypeName} getNotes={getData} />
//                                         </div>
//                                     </div>
//                                     <div className='table-box scroll-container-table'
//                                     >
//                                         <table className="table-css width-100vw">
//                                             <thead className="table-heading">
//                                                 <tr className="custom-table-head-tr">
//                                                     <th className="table-heading ">S.no.</th>
//                                                     <th className="table-heading text-left">Company Name</th>
//                                                     <th className="table-heading text-left">WorkType Name</th>
//                                                     <th className="table-heading text-left" style={{ paddingLeft: "10px" }}>Descriptions</th>
//                                                     <th className="table-heading text-center">Action</th>
//                                                 </tr>
//                                             </thead>
//                                             {buffer ? (

//                                                 <div className="spinner-bgdatil"></div>

//                                             ) :
//                                                 <tbody>
//                                                     {
//                                                         notesData

//                                                             .map((i, index) => (
//                                                                 <tr key={index} className="custom-table-head-td">
//                                                                     <td className="table-body ">{index + 1}.</td>
//                                                                     <td className="table-body text-left">{i.worktype?.company?.title}</td>
//                                                                     <td className="table-body text-left">{i.worktype?.title}</td>
//                                                                     <td className="table-body justify-left ">
//                                                                         <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginLeft: "20px" }}>
//                                                                             {i.data.map((item, index) => (
//                                                                                 <li key={index} style={{ listStyleType: "inherit" }}>
//                                                                                     {item.description}
//                                                                                 </li>
//                                                                             ))}
//                                                                         </ul>



//                                                                     </td>
//                                                                     <td>
//                                                                         <div className='flex-row justify-centyer'>
//                                                                             <UpdateNotes i={i} getNotes={getData} worktypeName={worktypeName} />
//                                                                             <DeleteNotes i={i} getData={getData} />
//                                                                         </div>
//                                                                     </td>
//                                                                 </tr>
//                                                             ))
//                                                     }
//                                                 </tbody>
//                                             }
//                                         </table>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }



const Notes = ({ worktypeName, notesData, getData, buffer }) => {
    const [searchQuery, setSearchQuery] = useState("");

    const q = searchQuery.toLowerCase();

    // search: work type, company ya description me match
    const filteredList = (notesData || []).filter((n) => {
        if (!q) return true;
        return (
            n.worktype?.title?.toLowerCase().includes(q) ||
            n.worktype?.company?.title?.toLowerCase().includes(q) ||
            (n.data || []).some((d) => d.description?.toLowerCase().includes(q))
        );
    });

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="wt-page">
                <div className="wt-card">
                    {/* ===== HEADER ===== */}
                    <div className="wt-header">
                        <div className="wt-header-left">
                            <div className="wt-header-icon">
                                <StickyNote size={20} />
                            </div>
                            <div>
                                <h4 className="wt-title">
                                    Notes
                                    <span className="wt-count">{filteredList.length}</span>
                                </h4>
                                <p className="wt-subtitle">Work type wise notes used in quotations</p>
                            </div>
                        </div>

                        <div className="wt-header-right">
                            <div className="wt-search">
                                <Search size={16} />
                                <input
                                    type="text"
                                    placeholder="Search work type or note..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {searchQuery && (
                                    <button
                                        type="button"
                                        className="wt-search-clear"
                                        onClick={() => setSearchQuery("")}
                                        title="Clear"
                                    >
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                            <AddNotes worktypeName={worktypeName} getNotes={getData} />
                        </div>
                    </div>

                    {/* ===== TABLE ===== */}
                    <div className="wt-table-wrap">
                        <table className="wt-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 70 }}>S.No.</th>
                                    <th style={{ width: 200 }}>Company Name</th>
                                    <th style={{ width: 220 }}>WorkType Name</th>
                                    <th>Descriptions</th>
                                    <th style={{ width: 140 }} className="wt-th-end">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {buffer ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <div className="wt-state">
                                                <div className="spinner-bgdatil"></div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : filteredList.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <div className="wt-state">
                                                <StickyNote size={30} />
                                                <p>{searchQuery ? "No matching notes" : "No notes added yet"}</p>
                                                <small>
                                                    {searchQuery
                                                        ? "Try a different search term"
                                                        : "Click the add button to create your first note"}
                                                </small>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredList.map((i, index) => (
                                        <tr key={i.id || index}>
                                            <td className="wt-sno">{index + 1}.</td>
                                            <td>{i.worktype?.company?.title || "-"}</td>
                                            <td>
                                                <span className="wt-chip">{i.worktype?.title || "-"}</span>
                                            </td>
                                            <td>
                                                <ul className="wt-notes-list">
                                                    {(i.data || []).map((item, idx) => (
                                                        <li key={item.id || idx}>{item.description}</li>
                                                    ))}
                                                </ul>
                                            </td>
                                            <td>
                                                <div className="wt-actions">
                                                    <UpdateNotes i={i} getNotes={getData} worktypeName={worktypeName} />
                                                    <DeleteNotes i={i} getData={getData} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notes; 
